import { apiService } from './api';
import { ChatDTO, RequestCreateChatDTO } from '../types/chat';
import { ChatMessageDTO, RequestCreateChatMessageDTO } from '../types/chat-message';
import { ChatScope } from '../types/chat-enums';
import { AxiosResponse } from 'axios';

const CHAT_BASE_PATH = '/Chat';

export const chatService = {
    // Получить чат по связанной сущности (например, Task)
    getChatByContextEntity: async (contextEntityId: string, scope: ChatScope): Promise<ChatDTO> => {
        const response = await apiService.get<ChatDTO>(`${CHAT_BASE_PATH}/context/${contextEntityId}/scope/${scope}`);
        return response.data;
    },

    // Создать чат
    createChat: async (request: RequestCreateChatDTO): Promise<ChatDTO> => {
        const response = await apiService.post<ChatDTO>(CHAT_BASE_PATH, request);
        return response.data;
    },

    // Отправить сообщение в чат
    sendMessage: async (request: RequestCreateChatMessageDTO): Promise<ChatMessageDTO> => {
        const response = await apiService.post<ChatMessageDTO>(`${CHAT_BASE_PATH}/messages`, request);
        return response.data;
    },

    // Получить сообщения чата
    getMessages: async (chatId: string, skip: number = 0, take: number = 50): Promise<ChatMessageDTO[]> => {
        const response = await apiService.get<ChatMessageDTO[]>(`${CHAT_BASE_PATH}/${chatId}/messages?skip=${skip}&take=${take}`);
        return response.data;
    },

    // Пометить сообщения как прочитанные
    markMessagesAsRead: async (chatId: string, lastReadMessageId: string): Promise<AxiosResponse<void>> => {
        return apiService.post<void>(`${CHAT_BASE_PATH}/${chatId}/messages/read/${lastReadMessageId}`);
    },

    // TODO: Добавить методы для участников чата (addParticipant, removeParticipant), если потребуется на фронтенде
};
